import Vue from 'vue';
import 'vue-material/dist/vue-material.min.css';
import {
  MdApp,
  MdIcon,
  MdCard,
  MdButton,
  MdRipple,
  MdToolbar,
  MdDialog,
} from 'vue-material/dist/components';

Vue.use(MdApp);
Vue.use(MdIcon);
Vue.use(MdCard);
Vue.use(MdButton);
Vue.use(MdRipple);
Vue.use(MdToolbar);
Vue.use(MdDialog);
